import gql from "graphql-tag";

export default gql`
  fragment CompanyIssuerFields on CompanyIssuer {
    _id
    vertical
    tickerSymbol
    exchangeId
    name
    country
    niceLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
    standardLogo {
      url
      geometry
      dominantColor
      colorPalette
    }
  }
`;
